module.exports = __webpack_public_path__ + "static/media/icon-heart-green.a82755f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-heart-green.svg
// module id = 1883
// module chunks = 0